import styled, { css } from 'styled-components'
import { Panel } from '../Panel'

export const MenuPanelStyled = styled(Panel)`
  transform: translateY(-10000px);
  transition: transform 3s ease-in-out;
  ${({ isOpen }: any) =>
    isOpen &&
    css`
      transform: translateY(0);
    `}
`

export const PanelContentWrapper = styled.div`
  white-space: initial;
  line-height: normal;
  width: 80vw;
  height: 100%;
  display: flex;
  gap: 1.5rem;
  color: #030852;
  .part-right {
    width: 100%;
    height: 100%;
    & li a::before {
      all: unset !important;
    }
    & li {
      padding: 0.31rem;
    }
    & li:has(ul) {
      display: flex;
      flex-direction: column;
      gap: 0.44rem;
      margin-bottom: 1.5rem;
      .section-wrapper {
        display: flex;
        flex-direction: column;
      }
      .title-brand,
      .title-category {
        font-size: 0.875rem;
        font-weight: 600;
        padding: 0.31rem;
      }
    }
    & li:not(:has(ul)) {
      min-height: 1.75rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &:hover {
        background-color: #d9d9d9;
      }
    }
    .panel-column {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      &:hover {
        background-color: unset;
      }
    }
  }
  .item-label {
    font-weight: bold;
    color: #000;
  }
  .subitem-label {
    color: #000;
  }
  .subitem {
    margin: 0;
    cursor: pointer;
    &:hover {
      background: #d9d9d9;
    }
  }
  .subitem-label {
    display: block;
  }
  .item-label {
    display: block;
    width: fit-content;
    height: fit-content;
  }
`
export const Wrapper = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const Container = styled.div`
  display: flex;
  flex: 1;
  background-color: #f4f4fc;
  overflow: hidden;
  height: calc(100% - 56px);
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2.5rem;
  overflow: hidden;
  position: relative;
  .link-page {
    position: absolute;
    top: 50px;
    right: 5%;
    text-decoration: underline;
  }
`

export const Title = styled.span`
  font-size: 1.6rem;
  font-weight: bold;
  border-bottom: 1px solid #03085240;
  margin-bottom: 0.8rem;
  padding-bottom: 1rem;
  .animated-link:hover {
    font-size: 1.2rem;
    animation: pulse;
  }
`

export const List = styled.ul`
  list-style: none;
  padding: 0;
`

export const Section = styled.li`
  margin-bottom: 16px;
`

export const ClickableItem = styled.div`
  cursor: pointer;
`

export const SubList = styled.ul`
  margin-top: 8px;
  padding-left: 16px;
`

export const SubItem = styled.li`
  cursor: pointer;
  font-size: 14px;
  :hover {
    background-color: #f4f4fc !important;
    border-radius: 15px !important;
  }
`

export const LinkWrapper = styled.a`
  display: block;
  cursor: pointer;
  padding: 0.35rem;
  :hover {
    border-radius: 15px;
    background-color: white;
  }
`

export const HeaderRight = styled.div`
  display: flex;
  justify-content: space-between;
`

export const BrandColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
`
export const ScrollableArea = styled.div`
  overflow-y: auto;
  max-height: 100%;
  padding-right: 8px;
`
export const StickyButton = styled.a`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 12px 0;
  background: #e6e6fa;
  display: flex;
  justify-content: center;
  z-index: 10;
  font-weight: bold;
`
